import React from 'react'
import { TABLE_TYPE, withTableContext } from '../../context/TableContext'
import { EKOM_LINKS } from '../../EKOM_LINKS'
import { useSubmissionsList } from '../../hooks/useSubmissionsList'
import { EKOM_STATES_LABEL, EKOM_TYPES_LABEL } from '../../utils/enums'
import { MsgsTable } from '../MsgsTable/MsgsTable'

interface iSubmissionsList {
  extSystemId: string
  extObjectId: string
}

const MsgsSubmissionsListMin = ({ extSystemId, extObjectId }: iSubmissionsList) => {

  const heads = [
    { id: 'deliveredAt', label: 'Datum ' },
    { id: 'state', label: '' },
    { id: 'type', label: 'Typ' },
    { id: 'recipientOrganizationName', label: 'Příjemce' },
  ]

  const { data, error, loading, totalCount } = useSubmissionsList(extSystemId, extObjectId)

  const tableData = data.map(msg => ({
    id: msg.id,
    deliveredAt: msg.deliveredAt,
    type: EKOM_TYPES_LABEL[msg.type],
    state: EKOM_STATES_LABEL[msg.state],
    link_type: EKOM_LINKS.listSubmissions + '/' + msg.id,
    recipientOrganizationName: msg.recipientOrganizationName,
    isRead: true
  }))

  return (
    <MsgsTable
      loading={loading}
      error={error}
      heads={heads}
      data={tableData}
      totalCount={totalCount}
      noFilter
    />
  )
}

export default withTableContext(MsgsSubmissionsListMin, TABLE_TYPE.SUBM, false)
